import { useState, useEffect } from "react";

const useConditionalTooltip = ({ textWrapperRef }) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  useEffect(() => {
    const checkTooltipVisibility = () => {
      if (textWrapperRef.current) {
        const { scrollWidth, clientWidth } = textWrapperRef.current;
        setIsTooltipVisible(scrollWidth > clientWidth);
      }
    };

    checkTooltipVisibility();
  }, [textWrapperRef]);

  return isTooltipVisible;
};

export default useConditionalTooltip;
